import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import React from 'react';
import { CpsSvgIcon } from '../../shared/CpsSvgIcon';

const ClearFiltersButton: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const clearAllFieldsFilters = () => {
    window.location.reload();
  };

  return (
    <div
      className={`chipsButtonLink`}
      title={translate('custom.toolbar.filterTagsClear')}
      onClick={clearAllFieldsFilters}
    >
      <CpsSvgIcon customIcon="clearFilterIcon" className={`cpsIcon`} />
    </div>
  );
};

export default ClearFiltersButton;
